<template>
  <div id="task-manager-sidebar" class="w-24 lg:w-64">
    <div class="h-16 flex items-center">
      <span class="font-semibold hidden lg:block mx-4">タスク種別</span>
    </div>
    <div v-for="(item, index) in menuItems" :key="index">
      <div
        class="task-category-label flex items-center justify-between"
        :class="{ 'task-category-label__selected': isSelectedItem(item.key) }"
        @click="clickLabel(item.key)"
      >
        <div class="flex items-center">
          <feather-icon
            :icon="categoryIcon(item.key)"
            svgClasses="h-5 w-5"
            class="mr-2"
          />
          <span class="hidden lg:block">{{ categoryName(item.key) }}</span>
        </div>
        <div class="count-badge ml-2">
          <span>{{ item.count() }}</span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { ColorMixin, DocumentMixin, TaskManagerMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import { TASK_MANAGER_CATEGORY } from "@/config/const";

const { mapActions, mapMutations, mapState } = createNamespacedHelpers("enterpriseBackgroundTaskManager");

export default {
  name: "TaskManagerSidehBar",

  mixins: [ColorMixin, DocumentMixin, TaskManagerMixin],
  data () {
    return {
      menuItems: [],
    }
  },
  computed: {
    ...mapState(["totalProgressTaskCount", "uploadProgressTaskCount", "downloadProgressTaskCount", "selectedFilterCategory"]),
    selectedItem(){
      return this.selectedFilterCategory
    }
  },
  methods: {
    ...mapActions(["fetchAllTaskList", "fetchProgressTaskCount"]),
    ...mapMutations(["SET_FILTER_CATEGORY", "SET_CURRENT_TASK_PAGE"]),
    isSelectedItem (item) {
      return item === this.selectedItem;
    },
    async clickLabel (key) {
      this.SET_FILTER_CATEGORY(key)
      this.SET_CURRENT_TASK_PAGE(1);
      await this.fetchAllTaskList();
    },
    allCount () {
      return this.totalProgressTaskCount;
    },
    uploadCount () {
      return this.uploadProgressTaskCount;
    },
    downloadCount () {
      return this.downloadProgressTaskCount;
    },
    categoryName (key) {
      return this.CATEGORY_ITEMS.find(item => item.key === key).name
    },
    categoryIcon (key) {
      return this.CATEGORY_ITEMS.find(item => item.key === key).icon
    }
  },
  beforeMount () {
    this.menuItems = [
      {
        key: TASK_MANAGER_CATEGORY.ALL,
        count: this.allCount,
      },
      {
        key: TASK_MANAGER_CATEGORY.UPLOAD,
        count: this.uploadCount
      },
      {
        key: TASK_MANAGER_CATEGORY.DOWNLOAD,
        count: this.downloadCount
      },
    ];
  },
  async mounted () {
    await this.fetchProgressTaskCount();
  }

}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/aisea/task-manager.scss";

#task-manager-sidebar {


  .task-category-label {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;

    .count-badge {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 24px;
      min-height: 24px;
      padding: 3px 6px;
      font-size: 12px;
      border-radius: 100%;
      background-color: $taskmanager-light-blue;
      color: $taskmanager-blue;
    }

    &:hover {
      background-color: $aisea-white;
    }

    &__selected {
      color: $aisea-blue;
      font-weight: 600;
    }
  }
}
</style>